import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import { isMacOs } from 'react-device-detect';
import { Link } from 'react-router-dom';

// import { get } from '../../core/client';
import { useAppSelector } from '../../store';
// import NewsShareModal from './EventsShareModal';

const Event = () => {
    const { events } = useAppSelector(state => state.hr);
    const { words }: any = useAppSelector(state => state.localization);
    // const { urlName }: any = useAppSelector(state => state.hrDetails);

    // const [newsOpenModal, setNewOpenModal] = useState(false);
    // const [newsModalData, setNewModalData] = useState();

    // const newDetailModal = async id => {
    //     await get<any>(`/hr/get-event-detail?eventId=` + id).then(res => setNewModalData(res?.result));

    //     setNewOpenModal(true);
    // };

    // const closeModal = () => {
    //     setNewOpenModal(false);
    // };

    return (
        <div className={isMacOs ? 'news-01 isMacOs' : 'news-01'} id="the-news">
            {/* <NewsShareModal newsModalData={newsModalData} closeModal={closeModal} newsOpenModal={newsOpenModal} /> */}
            <div className="c-wrapper">
                {events?.items?.length > 0 ? (
                    <div className="c-item-news">
                        <h1 className="c-item-01">Koç Gönüllüleri Projeleri</h1>

                        {events?.items?.filter(item => item.isVisible).map((item, index) => {
                            return (
                                <div key={'news' + index} className="c-item-02">
                                    <Link to={`/${words && words['WEB.eventsDetail']}/${item?.eventId}`} className="c-item-02-A">
                                        <img loading="lazy" src={item?.smallImageUrl} className="c-unit-01" />
                                    </Link>
                                    <div className="c-item-02-B">
                                        <div className="c-unit-01">{item?.title}</div>
                                        <div className="c-unit-02">{item?.text}</div>
                                        <div className="c-unit-03">
                                            <Link to={`/${words && words['WEB.eventsDetail']}/${item?.eventId}`} className="c-unit-03-A">
                                                Daha Fazla
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="spinner-02">
                        <CircularProgress size={100} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Event;
